import { VueConstructor } from 'vue'

import { logger } from '@/utils/logger'

export const currentContextForLogging: any = {}

// Vue 2.7 registers the global mixin on the Vue constructor; on the Vue 3 migration this
// function takes the `app` instance and uses app.mixin instead. Mirrors
// aven/src/config/initGlobalMixin.ts so the migration diff is small.
export const initGlobalMixin = (vue: VueConstructor) => {
    vue.mixin({
        created() {
            try {
                const name = this.name
                const vnode = this.$vnode
                const uid = this.uid as string
                if (name || vnode?.tag || uid) {
                    currentContextForLogging[name || vnode?.tag || uid] = this
                }
            } catch (e) {
                logger.fatal(`error adding logging context of component ${this?.name || this?.$vnode?.tag || this?.uid}`, e)
            }
        },
    })
}
